<ng-container *transloco="let t">
  <div class="experience-editor-tips" role="region" [attr.aria-label]="t('experience.editorQuote')">
    <section
      class="quote innerHtml"
      [ngClass]="{condensed: experienceStyle === ExperienceStyle.INSIDERS}"
      [innerHTML]="quote"
      data-cy="experience-editor-quote"
    ></section>
  </div>
</ng-container>
